<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="font-weight-medium py-2 flex-shrink-0 ml-2">
        สิทธิ์การลงเวลานอกสถานที่
      </span>
      <v-scroll-x-transition>
        <div style="display: flex" v-show="!formShow">
          <v-text-field
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            clearable
            flat
            solo
            dense
            hide-details
            placeholder="รหัส - ชื่อพนักงาน"
            @input="handleSearch"
            style="width: 240px; padding: 0 5px"
          ></v-text-field>
          <div
            class="d-flex align-center rounded"
            style="
              width: 260px;
              margin: 0 5px;
              cursor: pointer;
              background-color: white;
            "
          >
            <span
              class="flex-grow-1 pl-3 text-truncate"
              @click="handleOrganizationsFilter"
            >
              <span
                v-if="!filterOrganization.organization_uuid"
                class="grey--text"
              >
                หน่วยงาน
              </span>
              <span v-else>{{ filterOrganization.title_th }}</span>
            </span>
            <v-icon
              v-if="filterOrganization.organization_uuid"
              class="mr-2"
              @click="handleClearOrganizationsFilter"
            >
              mdi-close
            </v-icon>
            <v-icon class="mr-3" @click="handleOrganizationsFilter">
              mdi-tune
            </v-icon>
          </div>
          <v-dialog
            v-model="dialogOrganizationsFilter"
            scrollable
            width="420px"
          >
            <v-card>
              <v-card-title class="pt-0 px-4">
                <v-text-field
                  v-model="searchOrganizationsFilter"
                  prepend-inner-icon="mdi-magnify"
                  clearable
                  placeholder="รหัส - ชื่อหน่วยงาน"
                  hide-details
                  @input="handleSearchOrganizationsFilter"
                  :loading="loadingOrganizationsFilter"
                ></v-text-field>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text style="height: 300px" class="pa-0">
                <v-list>
                  <v-list-item-group>
                    <v-list-item
                      v-for="organization in organizationsFilter"
                      :key="organization.organization_uuid"
                      @click="handleOrganizationSelected(organization)"
                    >
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ organization.organization_code }} -
                          {{ organization.title_th }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <p
                      v-if="organizationsFilter.length === 0"
                      class="mt-5 text-center"
                    >
                      {{
                        loadingOrganizationsFilter
                          ? 'กำลังโหลดข้อมูล'
                          : 'ไม่มีข้อมูล'
                      }}
                    </p>
                  </v-list-item-group>
                  <v-list-item-group
                    v-if="
                      organizationsFilter.length > 0 &&
                      organizationsFilter.length < organizationsFilterTotal
                    "
                    v-intersect="onIntersect"
                  ></v-list-item-group>
                </v-list>
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::offsite_grant:create')"
            style="margin-top: 1px"
            color="primary"
            @click="handleAddForm"
          >
            <v-icon small left>mdi-plus</v-icon>เพิ่มการอนุญาต
          </v-btn>
        </div>
      </v-scroll-x-transition>
    </div>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading... Please wait"
      :headers="headers"
      :items="timeAttendanceOffSiteGrants"
      :options.sync="options"
      :server-items-length="totalTimeAttendanceOffSiteGrants"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
    >
      <template v-slot:item.full_name="{ item }">
        {{ item.employee.firstname_th }} {{ item.employee.lastname_th }}
      </template>
      <template v-slot:item.start_time="{ item }">
        <span v-if="item.start_time">{{
          item.start_time | dateTimeAttendanceFormat
        }}</span>
        <span v-else>ไม่ระบุเวลา</span>
      </template>
      <template v-slot:item.end_time="{ item }">
        <span v-if="item.end_time">{{
          item.end_time | dateTimeAttendanceFormat
        }}</span>
        <span v-else>ไม่ระบุเวลา</span>
      </template>
      <template v-slot:item.locations="{ item }">
        <span v-if="item.locations && item.locations.length > 0">
          <v-chip
            color="cyan"
            text-color="white"
            small
            class="mr-2 my-1"
            v-for="location in item.locations.slice(0, 3)"
            :key="location.offsite_location_uuid"
          >
            {{ location.offsite_location.title_th }}
          </v-chip>
          <v-chip outlined small v-if="item.locations.length > 3"
            >+ {{ item.locations.length - 3 }}</v-chip
          >
        </span>
        <span v-else>ไม่ระบุสถานที่</span>
      </template>
    </v-data-table>
    <TimeAttendanceOffSiteForm
      :formShow="formShow"
      :formAction="formAction"
      :timeAttendanceOffSiteGrant="timeAttendanceOffSiteGrant"
      :timeAttendanceOffSiteGrantInit="timeAttendanceOffSiteGrantInit"
      @isTimeAttendanceOffSiteGrantDataChange="
        handleTimeAttendanceOffSiteGrantFormDataChange
      "
      @formActionCompleted="handleTimeAttendanceOffSiteGrantFormActionCompleted"
      @onReset="handleTimeAttendanceOffSiteGrantFormReset"
      @onClickAddOffSiteLocation="timeAttendanceOffSiteLocationAddShow = true"
      @addTimeAttendanceOffSiteGrantSuccess="
        handleAddTimeAttendanceOffSiteGrantSuccess
      "
    />
    <TimeAttendanceOffSiteLocationAdd
      :formShow="timeAttendanceOffSiteLocationAddShow"
      :timeAttendanceOffSiteGrant="timeAttendanceOffSiteGrant"
      :timeAttendanceOffSiteGrantInit="timeAttendanceOffSiteGrantInit"
      @isTimeAttendanceOffSiteLocationAddDataChange="
        handleTimeAttendanceOffSiteLocationAddDataChange
      "
      @onClickBlack="timeAttendanceOffSiteLocationAddShow = false"
      @onClickAddLocation="handleOnClickAddLocation"
      @addTimeAttendanceOffSiteLocationAddSuccess="
        handleAddTimeAttendanceOffSiteLocationAddSuccess
      "
    />
    <TimeAttendanceLocationAdd
      :formShow="timeAttendanceLocationAddShow"
      :location="location"
      :locationInit="locationInit"
      @isTimeAttendanceLocationAddDataChange="
        handleTimeAttendanceLocationAddDataChange
      "
      @addTimeAttendanceLocationAddSuccess="
        handleAddTimeAttendanceLocationAddSuccess
      "
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <v-overlay
      :value="
        (formShow && formAction === 'add') ||
        timeAttendanceOffSiteLocationAddShow ||
        timeAttendanceLocationAddShow
      "
      z-index="0"
    ></v-overlay>
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-container>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import TimeAttendanceLocationAdd from '@/views/time-attendance/TimeAttendanceLocationAdd.vue'
import TimeAttendanceOffSiteForm from '@/views/time-attendance/TimeAttendanceOffSiteForm.vue'
import TimeAttendanceOffSiteLocationAdd from '@/views/time-attendance/TimeAttendanceOffSiteLocationAdd.vue'

export default {
  components: {
    TimeAttendanceOffSiteForm,
    TimeAttendanceOffSiteLocationAdd,
    TimeAttendanceLocationAdd,
    ConfirmDialog,
  },
  data() {
    return {
      dialogForbidden: false,
      location: {},
      locationInit: {},
      timeAttendanceOffSiteLocationAddShow: false,
      timeAttendanceLocationAddShow: false,
      isTimeAttendanceOffSiteLocationAddDataChange: false,
      isTimeAttendanceLocationAddDataChange: false,
      dialogOrganizationsFilter: false,
      organizationsFilter: [],
      organizationsFilterTotal: 0,
      organizationsFilterPage: 1,
      searchOrganizationsFilter: '',
      loadingOrganizationsFilter: false,
      filterOrganization: {},
      loading: false,
      options: {},
      sortBy: ['employee.employee_code'],
      sortDesc: [false],
      search: '',
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      formShow: false,
      formAction: '',
      timeAttendanceOffSiteGrant: { employeeSelected: {} },
      timeAttendanceOffSiteGrantInit: { employeeSelected: {} },
      isTimeAttendanceOffSiteGrantDataChange: false,
      timeout: null,
      headers: [
        { text: 'รหัสพนักงาน', value: 'employee.employee_code', width: '140' },
        { text: 'ชื่อพนักงาน', value: 'full_name' },
        { text: 'วันที่เริ่มต้น', value: 'start_time' },
        { text: 'วันที่สิ้นสุด', value: 'end_time' },
        { text: 'สถานที่', value: 'locations', sortable: false },
        {
          text: 'หน่วยงาน',
          value: 'employee.organization.title_th',
        },
      ],
    }
  },
  watch: {
    options: {
      handler() {
        this.getTimeAttendanceOffSiteGrants()
      },
      deep: true,
    },
  },
  filters: {
    dateTimeAttendanceFormat: function (value) {
      return moment.utc(value).format('DD/MM/YYYY, HH:mm')
    },
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    timeAttendanceOffSiteGrants() {
      return this.$store.state.timeAttendanceOffSiteGrant
        .timeAttendanceOffSiteGrants
    },
    totalTimeAttendanceOffSiteGrants() {
      return this.$store.state.timeAttendanceOffSiteGrant
        .totalTimeAttendanceOffSiteGrants
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'สิทธิ์การลงเวลานอกสถานที่',
        disabled: true,
      },
    ])
  },
  methods: {
    ...mapActions({
      fetchOrganizationsFilter: 'organization/fetchOrganizationsFilter',
      fetchTimeAttendanceOffSiteGrants:
        'timeAttendanceOffSiteGrant/fetchTimeAttendanceOffSiteGrants',
      fetchTimeAttendanceOffSiteGrant:
        'timeAttendanceOffSiteGrant/fetchTimeAttendanceOffSiteGrant',
    }),
    handleAddTimeAttendanceLocationAddSuccess() {
      this.timeAttendanceLocationAddShow = false
      this.location = { timezone: '+07:00' }
      this.locationInit = { timezone: '+07:00' }
    },
    handleOnClickAddLocation() {
      this.timeAttendanceLocationAddShow = true
      this.location = { timezone: '+07:00' }
      this.locationInit = { timezone: '+07:00' }
    },
    handleAddTimeAttendanceOffSiteLocationAddSuccess(
      timeAttendanceOffSiteGrant
    ) {
      this.timeAttendanceOffSiteLocationAddShow = false
      this.timeAttendanceOffSiteGrant = {
        ...timeAttendanceOffSiteGrant,
        employeeSelected: {
          text: `${timeAttendanceOffSiteGrant.employee.employee_code} - ${timeAttendanceOffSiteGrant.employee.firstname_th} ${timeAttendanceOffSiteGrant.employee.lastname_th}`,
          value: timeAttendanceOffSiteGrant.employee.employee_uuid,
        },
        date_start: timeAttendanceOffSiteGrant.start_time
          ? moment
              .utc(timeAttendanceOffSiteGrant.start_time)
              .format('YYYY-MM-DD')
          : '',
        time_start: timeAttendanceOffSiteGrant.start_time
          ? moment.utc(timeAttendanceOffSiteGrant.start_time).format('HH:mm')
          : '',
        date_end: timeAttendanceOffSiteGrant.end_time
          ? moment.utc(timeAttendanceOffSiteGrant.end_time).format('YYYY-MM-DD')
          : '',
        time_end: timeAttendanceOffSiteGrant.end_time
          ? moment.utc(timeAttendanceOffSiteGrant.end_time).format('HH:mm')
          : '',
        locations: timeAttendanceOffSiteGrant.locations
          ? [...timeAttendanceOffSiteGrant.locations]
          : [],
      }
      this.timeAttendanceOffSiteGrantInit = {
        ...timeAttendanceOffSiteGrant,
        employeeSelected: {
          text: `${timeAttendanceOffSiteGrant.employee.employee_code} - ${timeAttendanceOffSiteGrant.employee.firstname_th} ${timeAttendanceOffSiteGrant.employee.lastname_th}`,
          value: timeAttendanceOffSiteGrant.employee.employee_uuid,
        },
        date_start: timeAttendanceOffSiteGrant.start_time
          ? moment
              .utc(timeAttendanceOffSiteGrant.start_time)
              .format('YYYY-MM-DD')
          : '',
        time_start: timeAttendanceOffSiteGrant.start_time
          ? moment.utc(timeAttendanceOffSiteGrant.start_time).format('HH:mm')
          : '',
        date_end: timeAttendanceOffSiteGrant.end_time
          ? moment.utc(timeAttendanceOffSiteGrant.end_time).format('YYYY-MM-DD')
          : '',
        time_end: timeAttendanceOffSiteGrant.end_time
          ? moment.utc(timeAttendanceOffSiteGrant.end_time).format('HH:mm')
          : '',
        locations: timeAttendanceOffSiteGrant.locations
          ? [...timeAttendanceOffSiteGrant.locations]
          : [],
      }
    },
    handleAddTimeAttendanceOffSiteGrantSuccess(timeAttendanceOffSiteGrant) {
      this.timeAttendanceOffSiteGrant = {
        ...timeAttendanceOffSiteGrant,
        employeeSelected: {
          text: `${timeAttendanceOffSiteGrant.employee.employee_code} - ${timeAttendanceOffSiteGrant.employee.firstname_th} ${timeAttendanceOffSiteGrant.employee.lastname_th}`,
          value: timeAttendanceOffSiteGrant.employee.employee_uuid,
        },
        date_start: timeAttendanceOffSiteGrant.start_time
          ? moment
              .utc(timeAttendanceOffSiteGrant.start_time)
              .format('YYYY-MM-DD')
          : '',
        time_start: timeAttendanceOffSiteGrant.start_time
          ? moment.utc(timeAttendanceOffSiteGrant.start_time).format('HH:mm')
          : '',
        date_end: timeAttendanceOffSiteGrant.end_time
          ? moment.utc(timeAttendanceOffSiteGrant.end_time).format('YYYY-MM-DD')
          : '',
        time_end: timeAttendanceOffSiteGrant.end_time
          ? moment.utc(timeAttendanceOffSiteGrant.end_time).format('HH:mm')
          : '',
        locations: timeAttendanceOffSiteGrant.locations
          ? [...timeAttendanceOffSiteGrant.locations]
          : [],
      }
      this.timeAttendanceOffSiteGrantInit = {
        ...timeAttendanceOffSiteGrant,
        employeeSelected: {
          text: `${timeAttendanceOffSiteGrant.employee.employee_code} - ${timeAttendanceOffSiteGrant.employee.firstname_th} ${timeAttendanceOffSiteGrant.employee.lastname_th}`,
          value: timeAttendanceOffSiteGrant.employee.employee_uuid,
        },
        date_start: timeAttendanceOffSiteGrant.start_time
          ? moment
              .utc(timeAttendanceOffSiteGrant.start_time)
              .format('YYYY-MM-DD')
          : '',
        time_start: timeAttendanceOffSiteGrant.start_time
          ? moment.utc(timeAttendanceOffSiteGrant.start_time).format('HH:mm')
          : '',
        date_end: timeAttendanceOffSiteGrant.end_time
          ? moment.utc(timeAttendanceOffSiteGrant.end_time).format('YYYY-MM-DD')
          : '',
        time_end: timeAttendanceOffSiteGrant.end_time
          ? moment.utc(timeAttendanceOffSiteGrant.end_time).format('HH:mm')
          : '',
        locations: timeAttendanceOffSiteGrant.locations
          ? [...timeAttendanceOffSiteGrant.locations]
          : [],
      }
    },
    handleTimeAttendanceOffSiteLocationAddDataChange(value) {
      this.isTimeAttendanceOffSiteLocationAddDataChange = value
    },
    handleTimeAttendanceLocationAddDataChange(value) {
      this.isTimeAttendanceLocationAddDataChange = value
    },
    handleClearOrganizationsFilter() {
      this.filterOrganization = {}
      this.options.page = 1
      this.getTimeAttendanceOffSiteGrants()
    },
    handleOrganizationSelected(organization) {
      this.dialogOrganizationsFilter = false
      this.filterOrganization = { ...organization }
      this.options.page = 1
      this.getTimeAttendanceOffSiteGrants()
    },
    handleSearchOrganizationsFilter() {
      this.loadingOrganizationsFilter = true
      this.getOrganizationsFilterBySearch()
    },
    getOrganizationsFilterBySearch: _.debounce(async function () {
      this.organizationsFilterPage = 1

      const { total, organizations } = await this.getOrganizationsFilter()

      this.organizationsFilter = [...organizations]
      this.organizationsFilterTotal = total
    }, 1000),
    async onIntersect(entries, observer, isIntersecting) {
      if (isIntersecting) {
        this.organizationsFilterPage += 1

        const { total, organizations } = await this.getOrganizationsFilter()

        this.organizationsFilter = [
          ...this.organizationsFilter,
          ...organizations,
        ]
        this.organizationsFilterTotal = total
      }
    },
    async handleOrganizationsFilter() {
      this.dialogOrganizationsFilter = true
      this.organizationsFilterPage = 1

      const { total, organizations } = await this.getOrganizationsFilter()

      this.organizationsFilter = [...organizations]
      this.organizationsFilterTotal = total
    },
    async getOrganizationsFilter() {
      try {
        this.loadingOrganizationsFilter = true

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          params: {
            dpc: 'time-attendance-off-site-grant-to-list-organization',
            search: this.searchOrganizationsFilter || undefined,
            sort: 'organization_code:asc',
            field: 'organization_uuid,organization_code,title_th',
            limit: 10,
            offset: (this.organizationsFilterPage - 1) * 10,
          },
        }

        const response = await this.fetchOrganizationsFilter(payload)

        return response
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.loadingOrganizationsFilter = false
      }
    },
    handleSearch() {
      this.loading = true
      this.getTimeAttendanceOffSiteGransBySearch()
    },
    handleFilterOrganization() {
      this.options.page = 1
      this.getTimeAttendanceOffSiteGrants()
    },
    getTimeAttendanceOffSiteGransBySearch: _.debounce(function () {
      this.options.page = 1
      this.getTimeAttendanceOffSiteGrants()
    }, 1000),
    handleAddForm() {
      this.formShow = true
      this.formAction = 'add'

      this.timeAttendanceOffSiteGrant = { employeeSelected: {}, locations: [] }
      this.timeAttendanceOffSiteGrantInit = {
        employeeSelected: {},
        locations: [],
      }
    },
    classRowSelected(row) {
      if (
        this.timeAttendanceOffSiteGrant.time_attendance_offsite_grant_uuid ===
        row.time_attendance_offsite_grant_uuid
      )
        return 'row-selected'
    },
    async setDataRowSelected(row) {
      if (this.uiCtrl && !this.uiCtrl.isEnable('row:::offsite_grant:get')) {
        this.dialogForbidden = true
        return
      }

      try {
        await this.fetchTimeAttendanceOffSiteGrant({
          company_uuid: this.$store.state.authentication.company.company_uuid,
          time_attendance_offsite_grant_uuid:
            row.time_attendance_offsite_grant_uuid,
        })
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.dialogForbidden = true
        } else {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        }

        return
      }

      if (
        this.timeAttendanceOffSiteGrant.time_attendance_offsite_grant_uuid ===
        row.time_attendance_offsite_grant_uuid
      ) {
        this.formShow = false

        this.timeAttendanceOffSiteGrant = {
          employeeSelected: {},
          locations: [],
        }
        this.timeAttendanceOffSiteGrantInit = {
          employeeSelected: {},
          locations: [],
        }
        return
      }

      row.date_start = row.start_time
        ? moment.utc(row.start_time).format('YYYY-MM-DD')
        : ''
      row.time_start = row.start_time
        ? moment.utc(row.start_time).format('HH:mm')
        : ''
      row.date_end = row.end_time
        ? moment.utc(row.end_time).format('YYYY-MM-DD')
        : ''
      row.time_end = row.end_time
        ? moment.utc(row.end_time).format('HH:mm')
        : ''

      this.formShow = true
      this.formAction = 'edit'

      this.timeAttendanceOffSiteGrant = {
        employeeSelected: {
          text: `${row.employee.employee_code} - ${row.employee.firstname_th} ${row.employee.lastname_th}`,
          value: row.employee.employee_uuid,
        },
        ...row,
      }
      this.timeAttendanceOffSiteGrantInit = {
        employeeSelected: {
          text: `${row.employee.employee_code} - ${row.employee.firstname_th} ${row.employee.lastname_th}`,
          value: row.employee.employee_uuid,
        },
        ...row,
      }
    },
    handleRowSelected(row) {
      if (this.isTimeAttendanceOffSiteGrantDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleTimeAttendanceOffSiteGrantFormDataChange(value) {
      this.isTimeAttendanceOffSiteGrantDataChange = value
    },
    handleTimeAttendanceOffSiteGrantFormReset(formAction) {
      if (formAction === 'add') {
        this.timeAttendanceOffSiteGrant = {
          employeeSelected: {},
          locations: [],
        }
        this.timeAttendanceOffSiteGrantInit = {
          employeeSelected: {},
          locations: [],
        }
      } else {
        this.timeAttendanceOffSiteGrant = {
          ...this.timeAttendanceOffSiteGrantInit,
        }
      }
    },
    handleTimeAttendanceOffSiteGrantFormActionCompleted(formAction) {
      this.timeAttendanceOffSiteGrant = { employeeSelected: {}, locations: [] }
      this.timeAttendanceOffSiteGrantInit = {
        employeeSelected: {},
        locations: [],
      }
      this.formShow = false
    },
    getTimeAttendanceOffSiteGrants() {
      this.loading = true

      const { sortBy, sortDesc, page, itemsPerPage } = this.options

      let sort = ''
      const sortByKey = sortBy[0] || ''

      if (sortByKey === 'employee.employee_code')
        sort = 'employee.employee_code'
      if (sortByKey === 'full_name') sort = 'employee.firstname_th'
      if (sortByKey === 'start_time') sort = 'start_time'
      if (sortByKey === 'end_time') sort = 'end_time'
      if (sortByKey === 'employee.organization.title_th')
        sort = 'employee.organization.title_th'

      if (sortDesc.length > 0) {
        if (sortDesc[0]) {
          sort += `,desc`
        } else {
          sort += `,asc`
        }
      }

      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        params: {
          dpc: 'time-attendance-off-site-grant-to-list-time-attendance-off-site-grant',
          search: this.search || undefined,
          organization_uuid:
            this.filterOrganization.organization_uuid || undefined,
          sort,
          limit: `${itemsPerPage},${(page - 1) * itemsPerPage}`,
        },
      }

      this.fetchTimeAttendanceOffSiteGrants(payload)
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.formShow = false
      this.timeAttendanceOffSiteLocationAddShow = false
      this.timeAttendanceLocationAddShow = false

      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (
      this.isTimeAttendanceOffSiteGrantDataChange ||
      this.isTimeAttendanceOffSiteLocationAddDataChange ||
      this.isTimeAttendanceLocationAddDataChange
    ) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
